<template>
	<section>		
		<p class="f-20 f-m-14">
			<strong>Laporan</strong>
			<span class="title-date">{{ date | moment("dddd, DD MMMM YYYY")}}</span>
		</p>
		<hr class="mt-4 mt-m-1">

		<AdvanceFilter />
		<div class="row">
			<div class="col cole" v-if="data">
				<div class="frameworks">
					<Chart :data="data.barang" slug="paket" :type="label"/>
				</div>
			</div>
			<div class="col cole" v-if="data">
				<div class="frameworks">
					<Chart :data="data.pengiriman" slug="pengiriman" :type="label"/>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col cole" v-if="data">
				<div class="frameworks">
					<Chart :data="data.perjalanan" slug="perjalanan" :type="label"/>
				</div>
			</div>
			<div class="col cole" v-if="data">
				<div class="frameworks">
					<Chart :data="data.pendapatan" slug="pendapatan" :type="label"/>
				</div>
			</div>
		</div>
		<div class="row" v-if="pengiriman_lead_time">
			<div class="col cole">
				<div class="frameworks">
					<Chart :data="pengiriman_lead_time" slug="Lead Time (Pengiriman)" :type="label"/>
				</div>
			</div>
			<div class="col cole" style="box-shadow: 0 0 0 0;"></div>
		</div>
		<hr v-if="perjalanan_kendaraan_utilitas.isShow">
		<h5 v-if="perjalanan_kendaraan_utilitas.isShow"><b>Kendaraan</b></h5>
		<div class="d-flex flex-wrap">
			<div class="cole bar-chart" v-if="perjalanan_kendaraan_utilitas.isShow">
				<div class="frameworks">
					<header class="framework__header d-block">
						<strong class="framework__name">Utilitas</strong><br>
						<small>Persentase dari kapasitas kendaraan dan paket yang dibawa</small>
					</header>
					<apexchart
						type="bar" style="width: 100%"
						:options="perjalanan_kendaraan_utilitas.options" 
						:series="perjalanan_kendaraan_utilitas.series" 
						id="chart-perjalanan-kendaraan-utilitas">
					</apexchart>
				</div>
			</div>
			<div class="cole bar-chart" v-if="perjalanan_kendaraan_leadtime.isShow">
				<div class="frameworks">
					<header class="framework__header d-block">
						<strong class="framework__name">Lead Time</strong><br>
						<small>Waktu tempuh Kendaraan dari titik pengirim sampai titik penerima</small>
					</header>
					<apexchart
						type="bar" style="width: 100%"
						:options="perjalanan_kendaraan_leadtime.options" 
						:series="perjalanan_kendaraan_leadtime.series" 
						id="chart-perjalanan-kendaraan-leadtime">
					</apexchart>
				</div>
			</div>
			<div class="cole bar-chart" v-if="perjalanan_kendaraan_totalload.isShow">
				<div class="frameworks">
					<header class="framework__header d-block">
						<strong class="framework__name">Total Load</strong><br>
						<small>Total berat load yang dibawa Kendaraan dari titik pengirim sampai titik penerima</small>
					</header>
					<apexchart
						type="bar" style="width: 100%"
						:options="perjalanan_kendaraan_totalload.options" 
						:series="perjalanan_kendaraan_totalload.series" 
						id="chart-perjalanan-kendaraan-totalweight">
					</apexchart>
				</div>
			</div>
			<div class="cole bar-chart" v-if="perjalanan_kendaraan_revenue.isShow">
				<div class="frameworks">
					<header class="framework__header d-block">
						<strong class="framework__name">Total Revenue</strong><br>
						<small>Revenue dari titik pengirim sampai titik penerima</small>
					</header>
					<apexchart
						type="bar" style="width: 100%"
						:options="perjalanan_kendaraan_revenue.options" 
						:series="perjalanan_kendaraan_revenue.series" 
						id="chart-perjalanan-kendaraan-totalweight">
					</apexchart>
				</div>
			</div>
			<div class="cole bar-chart" v-if="perjalanan_kendaraan_jarak.isShow">
				<div class="frameworks">
					<header class="framework__header d-block">
						<strong class="framework__name">Jarak</strong><br>
						<small>Rata-rata jarak tempuh kendaraan</small>
					</header>
					<apexchart
						type="bar" style="width: 100%"
						:options="perjalanan_kendaraan_jarak.options" 
						:series="perjalanan_kendaraan_jarak.series" 
						id="chart-perjalanan-kendaraan-jarak">
					</apexchart>
				</div>
			</div>
			<div class="cole bar-chart" v-if="perjalanan_kendaraan_totaljarak.isShow">
				<div class="frameworks">
					<header class="framework__header d-block">
						<strong class="framework__name">Total Jarak</strong><br>
						<small>Total Jarak tempuh kendaraan</small>
					</header>
					<apexchart
						type="bar" style="width: 100%"
						:options="perjalanan_kendaraan_totaljarak.options" 
						:series="perjalanan_kendaraan_totaljarak.series" 
						id="chart-perjalanan-kendaraan-totaljarak">
					</apexchart>
				</div>
			</div>
		</div>
		<hr v-if="perjalanan_driver_leadtime.isShow">
		<h5 v-if="perjalanan_driver_leadtime.isShow"><b>Driver</b></h5>
		<div class="d-flex flex-wrap">
			<div class="cole bar-chart" v-if="perjalanan_driver_leadtime.isShow">
				<div class="frameworks">
					<header class="framework__header d-block">
						<strong class="framework__name">Lead Time</strong><br>
						<small>Waktu tempuh Kendaraan dari titik pengirim sampai titik penerima per driver</small>
					</header>
					<apexchart
						type="bar" style="width: 100%"
						:options="perjalanan_driver_leadtime.options" 
						:series="perjalanan_driver_leadtime.series" 
						id="chart-perjalanan-driver-leadtime">
					</apexchart>
				</div>
			</div>
			<div class="cole bar-chart" v-if="perjalanan_driver_totaltime.isShow">
				<div class="frameworks">
					<header class="framework__header d-block">
						<strong class="framework__name">Total Time</strong><br>
						<small>Total waktu tempuh driver</small>
					</header>
					<apexchart
						type="bar" style="width: 100%"
						:options="perjalanan_driver_totaltime.options" 
						:series="perjalanan_driver_totaltime.series" 
						id="chart-perjalanan-driver-totaltime">
					</apexchart>
				</div>
			</div>
			<div class="cole bar-chart" v-if="perjalanan_driver_jarak.isShow">
				<div class="frameworks">
					<header class="framework__header d-block">
						<strong class="framework__name">Jarak</strong><br>
						<small>Rata-rata jarak tempuh driver</small>
					</header>
					<apexchart
						type="bar" style="width: 100%"
						:options="perjalanan_driver_jarak.options" 
						:series="perjalanan_driver_jarak.series" 
						id="chart-perjalanan-driver-jarak">
					</apexchart>
				</div>
			</div>
			<div class="cole bar-chart" v-if="perjalanan_driver_totaljarak.isShow">
				<div class="frameworks">
					<header class="framework__header d-block">
						<strong class="framework__name">Total Jarak</strong><br>
						<small>Total Jarak tempuh driver</small>
					</header>
					<apexchart
						type="bar" style="width: 100%"
						:options="perjalanan_driver_totaljarak.options" 
						:series="perjalanan_driver_totaljarak.series" 
						id="chart-perjalanan-driver-totaljarak">
					</apexchart>
				</div>
			</div>
		</div>
		<img src="img/group-311.png" alt="Bisa Cek" class="mt-5 hide-on-mobile" style="width: 13%">
	</section>
</template>

<script>
import AdvanceFilter from './components/AdvanceFilter'
import Chart from '@/components/Chart'
import { EventBus } from '@/plugins/bus.js'
export default {
	name: 'Report',
	components: {
		AdvanceFilter,
		Chart
	},
	data(){
		return{
			date: new Date(),
			data: null,
			advanceFilter: {
				type		: 1,
				date		: this.$moment().format('YYYY-MM-DD'),
				month		: "",
				year		: "",
				date_start	: "",
				date_end	: "",
			},
			pengiriman_lead_time: null,
			perjalanan_kendaraan_utilitas: {
				options: {
					chart: {
						id: 'chart-perjalanan-kendaraan-utilitas'
					},
					xaxis: {
						categories: []
					},
					yaxis: {
						labels: {
							formatter: function (value) {
								return value + ' %';
							}
						},
					},
				},
				series: [{
					name: 'Utilitas',
					data: []
				}],
				isShow: false
			},
			perjalanan_kendaraan_leadtime: {
				options: {
					chart: {
						id: 'chart-perjalanan-kendaraan-leadtime'
					},
					xaxis: {
						categories: []
					},
					yaxis: {
						labels: {
							formatter: function (value) {
								return value + ' Day';
							}
						},
					},
				},
				series: [{
					name: 'Lead Time (day)',
					data: []
				}],
				isShow: false
			},
			perjalanan_kendaraan_totalload: {
				options: {
					chart: {
						id: 'chart-perjalanan-kendaraan-totalload'
					},
					xaxis: {
						categories: []
					},
					yaxis: {
						labels: {
							formatter: function (value) {
								return value + ' Kg';
							}
						},
					},
				},
				series: [{
					name: 'Total Load (kg)',
					data: []
				}],
				isShow: false
			},
			perjalanan_kendaraan_revenue: {
				options: {
					chart: {
						id: 'chart-perjalanan-kendaraan-revenue'
					},
					xaxis: {
						categories: [],
					},
					yaxis: {
						labels: {
							formatter: function (value) {
								return 'Rp. ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
							}
						},
					},
				},
				series: [{
					name: 'Total Revenue',
					data: []
				}],
				isShow: false
			},
			perjalanan_kendaraan_jarak: {
				options: {
					chart: {
						id: 'chart-perjalanan-kendaraan-jarak'
					},
					xaxis: {
						categories: [],
					},
					yaxis: {
						labels: {
							formatter: function (value) {
								return value + ' KM';
							}
						},
					},
				},
				series: [{
					name: 'Jarak',
					data: []
				}],
				isShow: false
			},
			perjalanan_kendaraan_totaljarak: {
				options: {
					chart: {
						id: 'chart-perjalanan-kendaraan-totaljarak'
					},
					xaxis: {
						categories: [],
					},
					yaxis: {
						labels: {
							formatter: function (value) {
								return value + ' KM';
							}
						},
					},
				},
				series: [{
					name: 'Total Jarak',
					data: []
				}],
				isShow: false
			},
			perjalanan_driver_leadtime: {
				options: {
					chart: {
						id: 'chart-perjalanan-driver-leadtime'
					},
					xaxis: {
						categories: []
					},
					yaxis: {
						labels: {
							formatter: function (value) {
								return value + ' Day';
							}
						},
					},
				},
				series: [{
					name: 'Lead Time (day)',
					data: []
				}],
				isShow: false
			},
			perjalanan_driver_totaltime: {
				options: {
					chart: {
						id: 'chart-perjalanan-driver-totaltime'
					},
					xaxis: {
						categories: []
					},
					yaxis: {
						labels: {
							formatter: function (value) {
								return value + ' Day';
							}
						},
					},
				},
				series: [{
					name: 'Total Time (day)',
					data: []
				}],
				isShow: false
			},
			perjalanan_driver_jarak: {
				options: {
					chart: {
						id: 'chart-perjalanan-driver-jarak'
					},
					xaxis: {
						categories: [],
					},
					yaxis: {
						labels: {
							formatter: function (value) {
								return value + ' KM';
							}
						},
					},
				},
				series: [{
					name: 'Jarak',
					data: []
				}],
				isShow: false
			},
			perjalanan_driver_totaljarak: {
				options: {
					chart: {
						id: 'chart-perjalanan-driver-totaljarak'
					},
					xaxis: {
						categories: [],
					},
					yaxis: {
						labels: {
							formatter: function (value) {
								return value + ' KM';
							}
						},
					},
				},
				series: [{
					name: 'Total Jarak',
					data: []
				}],
				isShow: false
			},
		}
	},
	computed: {
		label() {
			let _ = this
			let data = "Daily"
			switch (_.advanceFilter.type) {
				case "1":
					data = 'Daily';
					break;
				case "2":
					data = 'Monthly';
					break;
				case "3":
					data = 'Yearly';
					break;
				case "4":
					data = 'Date Range';
					break;
			
				default:
					break;
			}
			return data;
		}
	},
	methods: {
		get() {
			let _ = this
			_.data = null
			_.axios.get('/report'  
				+ '?start_date=' + _.advanceFilter.date_start
				+ '&end_date=' + _.advanceFilter.date_end 
				+ '&date=' + _.advanceFilter.date
				+ '&month=' + _.advanceFilter.month
				+ '&year=' + _.advanceFilter.year
				+ '&type=' + _.advanceFilter.type
			).then(resp=>{
				_.data = resp.data.data 
			})
			.catch(err=>{
				console.log(err)
			})
		},
		get_pengiriman_leadtime() {
			let _ = this
			_.axios.get('/report/pengiriman/lead_time'  
				+ '?start_date=' + _.advanceFilter.date_start
				+ '&end_date=' + _.advanceFilter.date_end 
				+ '&date=' + _.advanceFilter.date
				+ '&month=' + _.advanceFilter.month
				+ '&year=' + _.advanceFilter.year
				+ '&type=' + _.advanceFilter.type
			).then(resp=>{
				_.pengiriman_lead_time = resp.data.data
			})
			.catch(err=>{
				console.log(err)
			})
		},
		get_perjalanan_kendaraan_utilitas(){
			let _ = this
			_.perjalanan_kendaraan_utilitas.isShow = false
			_.axios.get('/report/perjalanan/kendaraan/utilitas'  
				+ '?start_date=' + _.advanceFilter.date_start
				+ '&end_date=' + _.advanceFilter.date_end 
				+ '&date=' + _.advanceFilter.date
				+ '&month=' + _.advanceFilter.month
				+ '&year=' + _.advanceFilter.year
				+ '&type=' + _.advanceFilter.type
			).then(resp=>{
				_.perjalanan_kendaraan_utilitas.series[0].data = []
                _.perjalanan_kendaraan_utilitas.options.xaxis.categories = []

				let data = resp.data.data
				if (data){
					data.forEach(elm => {
						_.perjalanan_kendaraan_utilitas.options.xaxis.categories.push(elm.id_vehicle)
					});
					data.forEach(elm => {
						_.perjalanan_kendaraan_utilitas.series[0].data.push(elm.utilitas)
					});
				}
				_.perjalanan_kendaraan_utilitas.isShow = true
			})
			.catch(err=>{
				console.log(err)
			})
		},
		get_perjalanan_kendaraan_leadtime(){
			let _ = this
			_.perjalanan_kendaraan_leadtime.isShow = false
			_.axios.get('/report/perjalanan/kendaraan/leadtime'  
				+ '?start_date=' + _.advanceFilter.date_start
				+ '&end_date=' + _.advanceFilter.date_end 
				+ '&date=' + _.advanceFilter.date
				+ '&month=' + _.advanceFilter.month
				+ '&year=' + _.advanceFilter.year
				+ '&type=' + _.advanceFilter.type
			).then(resp=>{
				_.perjalanan_kendaraan_leadtime.series[0].data = []
                _.perjalanan_kendaraan_leadtime.options.xaxis.categories = []

				let data = resp.data.data
				if (data){
					data.forEach(elm => {
						_.perjalanan_kendaraan_leadtime.options.xaxis.categories.push(elm.id_vehicle)
					});
					data.forEach(elm => {
						_.perjalanan_kendaraan_leadtime.series[0].data.push(elm.avg_hari)
					});
				}
				_.perjalanan_kendaraan_leadtime.isShow = true
			})
			.catch(err=>{
				console.log(err)
			})
		},
		get_perjalanan_kendaraan_totalload(){
			let _ = this
			_.perjalanan_kendaraan_totalload.isShow = false
			_.axios.get('/report/perjalanan/kendaraan/totalload'  
				+ '?start_date=' + _.advanceFilter.date_start
				+ '&end_date=' + _.advanceFilter.date_end 
				+ '&date=' + _.advanceFilter.date
				+ '&month=' + _.advanceFilter.month
				+ '&year=' + _.advanceFilter.year
				+ '&type=' + _.advanceFilter.type
			).then(resp=>{
				_.perjalanan_kendaraan_totalload.series[0].data = []
                _.perjalanan_kendaraan_totalload.options.xaxis.categories = []

				let data = resp.data.data
				if (data){
					data.forEach(elm => {
						_.perjalanan_kendaraan_totalload.options.xaxis.categories.push(elm.id_vehicle)
					});
					data.forEach(elm => {
						_.perjalanan_kendaraan_totalload.series[0].data.push(elm.utilitas)
					});
				}
				_.perjalanan_kendaraan_totalload.isShow = true
			})
			.catch(err=>{
				console.log(err)
			})
		},
		get_perjalanan_kendaraan_revenue(){
			let _ = this
			_.perjalanan_kendaraan_revenue.isShow = false
			_.axios.get('/report/perjalanan/kendaraan/revenue'  
				+ '?start_date=' + _.advanceFilter.date_start
				+ '&end_date=' + _.advanceFilter.date_end 
				+ '&date=' + _.advanceFilter.date
				+ '&month=' + _.advanceFilter.month
				+ '&year=' + _.advanceFilter.year
				+ '&type=' + _.advanceFilter.type
			).then(resp=>{
				_.perjalanan_kendaraan_revenue.series[0].data = []
                _.perjalanan_kendaraan_revenue.options.xaxis.categories = []

				let data = resp.data.data
				if (data){
					data.forEach(elm => {
						_.perjalanan_kendaraan_revenue.options.xaxis.categories.push(elm.id_vehicle)
					});
					data.forEach(elm => {
						_.perjalanan_kendaraan_revenue.series[0].data.push(elm.utilitas)
					});
				}
				_.perjalanan_kendaraan_revenue.isShow = true
			})
			.catch(err=>{
				console.log(err)
			})
		},
		get_perjalanan_kendaraan_jarak(){
			let _ = this
			_.perjalanan_kendaraan_jarak.isShow = false
			_.axios.get('/report/perjalanan/kendaraan/jarak'  
				+ '?start_date=' + _.advanceFilter.date_start
				+ '&end_date=' + _.advanceFilter.date_end 
				+ '&date=' + _.advanceFilter.date
				+ '&month=' + _.advanceFilter.month
				+ '&year=' + _.advanceFilter.year
				+ '&type=' + _.advanceFilter.type
			).then(resp=>{
				_.perjalanan_kendaraan_jarak.series[0].data = []
                _.perjalanan_kendaraan_jarak.options.xaxis.categories = []

				let data = resp.data.data
				if (data){
					data.forEach(elm => {
						_.perjalanan_kendaraan_jarak.options.xaxis.categories.push(elm.id_vehicle)
					});
					data.forEach(elm => {
						_.perjalanan_kendaraan_jarak.series[0].data.push(elm.jarak)
					});
				}
				_.perjalanan_kendaraan_jarak.isShow = true
			})
			.catch(err=>{
				console.log(err)
			})
		},
		get_perjalanan_kendaraan_totaljarak(){
			let _ = this
			_.perjalanan_kendaraan_totaljarak.isShow = false
			_.axios.get('/report/perjalanan/kendaraan/totaljarak'  
				+ '?start_date=' + _.advanceFilter.date_start
				+ '&end_date=' + _.advanceFilter.date_end 
				+ '&date=' + _.advanceFilter.date
				+ '&month=' + _.advanceFilter.month
				+ '&year=' + _.advanceFilter.year
				+ '&type=' + _.advanceFilter.type
			).then(resp=>{
				_.perjalanan_kendaraan_totaljarak.series[0].data = []
                _.perjalanan_kendaraan_totaljarak.options.xaxis.categories = []

				let data = resp.data.data
				if (data){
					data.forEach(elm => {
						_.perjalanan_kendaraan_totaljarak.options.xaxis.categories.push(elm.id_vehicle)
					});
					data.forEach(elm => {
						_.perjalanan_kendaraan_totaljarak.series[0].data.push(elm.jarak)
					});
				}
				_.perjalanan_kendaraan_totaljarak.isShow = true
			})
			.catch(err=>{
				console.log(err)
			})
		},
		get_perjalanan_driver_leadtime(){
			let _ = this
			_.perjalanan_driver_leadtime.isShow = false
			_.axios.get('/report/perjalanan/driver/leadtime'  
				+ '?start_date=' + _.advanceFilter.date_start
				+ '&end_date=' + _.advanceFilter.date_end 
				+ '&date=' + _.advanceFilter.date
				+ '&month=' + _.advanceFilter.month
				+ '&year=' + _.advanceFilter.year
				+ '&type=' + _.advanceFilter.type
			).then(resp=>{
				_.perjalanan_driver_leadtime.series[0].data = []
                _.perjalanan_driver_leadtime.options.xaxis.categories = []

				let data = resp.data.data
				if (data){
					data.forEach(elm => {
						_.perjalanan_driver_leadtime.options.xaxis.categories.push(elm.id_driver_1)
					});
					data.forEach(elm => {
						_.perjalanan_driver_leadtime.series[0].data.push(elm.avg_hari)
					});
				}
				_.perjalanan_driver_leadtime.isShow = true
			})
			.catch(err=>{
				console.log(err)
			})
		},
		get_perjalanan_driver_totaltime(){
			let _ = this
			_.perjalanan_driver_totaltime.isShow = false
			_.axios.get('/report/perjalanan/driver/totaltime'  
				+ '?start_date=' + _.advanceFilter.date_start
				+ '&end_date=' + _.advanceFilter.date_end 
				+ '&date=' + _.advanceFilter.date
				+ '&month=' + _.advanceFilter.month
				+ '&year=' + _.advanceFilter.year
				+ '&type=' + _.advanceFilter.type
			).then(resp=>{
				_.perjalanan_driver_totaltime.series[0].data = []
                _.perjalanan_driver_totaltime.options.xaxis.categories = []

				let data = resp.data.data
				if (data){
					data.forEach(elm => {
						_.perjalanan_driver_totaltime.options.xaxis.categories.push(elm.id_driver_1)
					});
					data.forEach(elm => {
						_.perjalanan_driver_totaltime.series[0].data.push(elm.avg_hari)
					});
				}
				_.perjalanan_driver_totaltime.isShow = true
			})
			.catch(err=>{
				console.log(err)
			})
		},
		get_perjalanan_driver_jarak(){
			let _ = this
			_.perjalanan_driver_jarak.isShow = false
			_.axios.get('/report/perjalanan/driver/jarak'  
				+ '?start_date=' + _.advanceFilter.date_start
				+ '&end_date=' + _.advanceFilter.date_end 
				+ '&date=' + _.advanceFilter.date
				+ '&month=' + _.advanceFilter.month
				+ '&year=' + _.advanceFilter.year
				+ '&type=' + _.advanceFilter.type
			).then(resp=>{
				_.perjalanan_driver_jarak.series[0].data = []
                _.perjalanan_driver_jarak.options.xaxis.categories = []

				let data = resp.data.data
				if (data){
					data.forEach(elm => {
						_.perjalanan_driver_jarak.options.xaxis.categories.push(elm.id_driver_1)
					});
					data.forEach(elm => {
						_.perjalanan_driver_jarak.series[0].data.push(elm.jarak)
					});
				}
				_.perjalanan_driver_jarak.isShow = true
			})
			.catch(err=>{
				console.log(err)
			})
		},
		get_perjalanan_driver_totaljarak(){
			let _ = this
			_.perjalanan_driver_totaljarak.isShow = false
			_.axios.get('/report/perjalanan/driver/totaljarak'  
				+ '?start_date=' + _.advanceFilter.date_start
				+ '&end_date=' + _.advanceFilter.date_end 
				+ '&date=' + _.advanceFilter.date
				+ '&month=' + _.advanceFilter.month
				+ '&year=' + _.advanceFilter.year
				+ '&type=' + _.advanceFilter.type
			).then(resp=>{
				_.perjalanan_driver_totaljarak.series[0].data = []
                _.perjalanan_driver_totaljarak.options.xaxis.categories = []

				let data = resp.data.data
				if (data){
					data.forEach(elm => {
						_.perjalanan_driver_totaljarak.options.xaxis.categories.push(elm.id_driver_1)
					});
					data.forEach(elm => {
						_.perjalanan_driver_totaljarak.series[0].data.push(elm.jarak)
					});
				}
				_.perjalanan_driver_totaljarak.isShow = true
			})
			.catch(err=>{
				console.log(err)
			})
		},
	},
	beforeDestroy(){
		EventBus.$off('setAdvanceFilter')
    },
	mounted() {
		let _ = this
		_.get()
		_.get_pengiriman_leadtime()
		_.get_perjalanan_kendaraan_utilitas()
		_.get_perjalanan_kendaraan_leadtime()
		_.get_perjalanan_kendaraan_totalload()
		_.get_perjalanan_kendaraan_revenue()
		_.get_perjalanan_kendaraan_jarak()
		_.get_perjalanan_kendaraan_totaljarak()
		_.get_perjalanan_driver_leadtime()
		_.get_perjalanan_driver_totaltime()
		_.get_perjalanan_driver_jarak()
		_.get_perjalanan_driver_totaljarak()
		
		EventBus.$on('setAdvanceFilter', query => {
			_.advanceFilter = query
			_.get()
			_.get_pengiriman_leadtime()
			_.get_perjalanan_kendaraan_utilitas()
			_.get_perjalanan_kendaraan_leadtime()
			_.get_perjalanan_kendaraan_totalload()
			_.get_perjalanan_kendaraan_revenue()
			_.get_perjalanan_kendaraan_jarak()
			_.get_perjalanan_kendaraan_totaljarak()
			_.get_perjalanan_driver_leadtime()
			_.get_perjalanan_driver_totaltime()
			_.get_perjalanan_driver_jarak()
			_.get_perjalanan_driver_totaljarak()
		})
	}
}
</script>